(() => {
    const isEstatePage = window.isEstatePage;

    if (isEstatePage) {
        var recentlyViewed = [];
        const recentlyViewedCookie = document.cookie.split('; ').find(row => row.startsWith('recentlyViewed'));

        const expiryDate = new Date();
        expiryDate.setMonth(expiryDate.getMonth() + 12);

        if (recentlyViewedCookie) {
            const values = recentlyViewedCookie.split('=')[1];

            if (values) {
                recentlyViewed = values.split(',');
            }
        }

        if (!recentlyViewed.includes(window.entryId)) {
            recentlyViewed.push(window.entryId);

            document.cookie = "recentlyViewed=" + recentlyViewed.toString() + ";path=/;expires=" + expiryDate.toUTCString();
        }
    }
})();
